/* Bandeau de consentement (snippets/mi-cookie-banner.liquid) branché sur l'API Customer Privacy de Shopify.
   - Aucun suivi avant choix : le bandeau ne fait qu'appeler setTrackingConsent ; Shopify mémorise le choix et applique ses signaux (région, Global Privacy Control).
   - Le bandeau n'apparaît que si shouldShowBanner() est vrai (pas de choix mémorisé et région soumise au consentement).
   - Les boutons [data-mi-cookie-prefs] (pied de page) rouvrent le panneau de préférences. */
(function () {
  var root = document.querySelector('[data-mi-ck]');
  if (!root || !window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
  var bar = root.querySelector('[data-ck-bar]');
  var panel = root.querySelector('[data-ck-panel]');
  var customBtn = root.querySelector('[data-ck-custom]');
  var switches = [].slice.call(root.querySelectorAll('[data-ck-switch]'));
  var prefBtns = [].slice.call(document.querySelectorAll('[data-mi-cookie-prefs]'));
  var cp = null;
  var opener = null;

  function sizeVar() {
    document.documentElement.style.setProperty('--mi-ck-h', root.hidden ? '0px' : root.offsetHeight + 'px');
  }
  function open() {
    root.hidden = false;
    document.documentElement.classList.add('mi-ck-open');
    sizeVar();
  }
  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('mi-ck-open');
    sizeVar();
  }
  function showBar() {
    panel.hidden = true; bar.hidden = false; customBtn.setAttribute('aria-expanded', 'false');
    open();
  }
  function showPanel(from) {
    var cv = (cp && cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    switches.forEach(function (s) { s.checked = cv[s.getAttribute('data-ck-switch')] === 'yes'; });
    opener = from || null;
    bar.hidden = true; panel.hidden = false; customBtn.setAttribute('aria-expanded', 'true');
    open();
    var t = root.querySelector('#mi-ck-panel-title');
    if (t) t.focus({ preventScroll: true });
  }
  function noInteraction() {
    var g = typeof cp.getTrackingConsent === 'function' ? cp.getTrackingConsent() : '';
    if (g) return g === 'no_interaction';
    var cv = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    return !(cv.analytics || cv.marketing || cv.preferences || cv.sale_of_data);
  }
  function leavePanel() {
    var back = opener; opener = null;
    if (back && back !== customBtn) { close(); back.focus(); return; }
    if (cp && cp.shouldShowBanner && cp.shouldShowBanner() && noInteraction()) { showBar(); customBtn.focus(); }
    else { close(); }
  }
  function save(a, m, p) {
    if (!cp) return;
    cp.setTrackingConsent({ analytics: a, marketing: m, preferences: p, sale_of_data: m }, function () {
      var back = opener; opener = null;
      close();
      if (back && back !== customBtn && back.focus) back.focus();
    });
  }

  root.querySelector('[data-ck-accept]').addEventListener('click', function () { save(true, true, true); });
  root.querySelector('[data-ck-decline]').addEventListener('click', function () { save(false, false, false); });
  customBtn.addEventListener('click', function () { showPanel(customBtn); });
  root.querySelector('[data-ck-close]').addEventListener('click', leavePanel);
  panel.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = {};
    switches.forEach(function (s) { v[s.getAttribute('data-ck-switch')] = s.checked; });
    save(!!v.analytics, !!v.marketing, !!v.preferences);
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); leavePanel(); }
  });
  prefBtns.forEach(function (el) {
    el.addEventListener('click', function () { showPanel(el); });
  });
  window.addEventListener('resize', function () { if (!root.hidden) sizeVar(); });

  function ready() {
    cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp || typeof cp.setTrackingConsent !== 'function') return;
    var pb = window.privacyBanner;
    if (pb && typeof pb.showBanner === 'function') { try { pb.showBanner = function () { return Promise.resolve(); }; } catch (e) {} }
    prefBtns.forEach(function (el) { el.hidden = false; });
    /* shouldShowBanner() reste vrai après un choix (mesuré le 5 oct.) : on exige aussi l'état no_interaction. */
    if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() && noInteraction()) showBar();
  }
  try {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      ready();
    });
  } catch (e) { /* boutique utilisable sans bandeau */ }
})();
